import './App.css';
import Login from './components/Login';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom'
import UpdatePage from './components/tabs/Updates';
import Feed from './components/tabs/Feed';
import ImageRating from './components/tabs/ImageRating';
import Verified from './components/tabs/Verified';
import Bios from './components/tabs/Bios';
import Stories from './components/tabs/Stories';
import Member from './components/tabs/Member';
import Banned from './components/tabs/Banned';
import Reports from './components/tabs/Reports';
import Moderated from './components/tabs/Moderated';
import Memberboard from './components/tabs/Memberboard';
import Images from './components/tabs/Images';
import PeoplePremiuimRecheck from './components/tabs/PeoplePremiuimRecheck';
import BaitProfiles from './components/tabs/BaitProfiles';
import PhoneNumber from './components/tabs/PhoneNumber';
import ImageLabel from './components/tabs/ImageLabel';
import AutoCurateFeedNew from './components/tabs/AutoCurateFeedNew';
import FeedAutoCurated from './components/tabs/FeedAutoCurated';
import Autofeed from './components/tabs/Autofeed';
import Event from './components/tabs/Event';
import PeopleHNI from './components/tabs/PeopleHNI';
import Sharing from './components/tabs/Sharing';
import AutoUpdatesImages from './components/tabs/AutoUpdatesImages';

const router = createBrowserRouter([
    { element: <Login />, path: '/login' },
    { element: <UpdatePage />, path: '/updates' },
    { element: <Feed />, path: '/feed' },
    { element: <AutoCurateFeedNew />, path: '/autoCuratefeed' },
    { element: <FeedAutoCurated />, path: '/feedAutoCurated' },
    { element: <Autofeed />, path: '/autofeed' },
    { element: <ImageRating />, path: '/rateimages' },
    { element: <Navigate to="/people" replace />, path: '/curatorsrating' },
    { element: <Verified />, path: '/verified' },
    { element: <Bios />, path: '/bios' },
    { element: <Stories />, path: '/stories' },
    { element: <Member />, path: '/member' },
    { element: <Banned />, path: '/banned' },
    { element: <Reports />, path: '/reports' },
    { element: <Moderated />, path: '/moderated' },
    { element: <Memberboard />, path: '/memberboard' },
    { element: <Images />, path: '/images' },
    { element: <AutoUpdatesImages />, path: '/auto-updates-images' },
    { element: <PeoplePremiuimRecheck currentTab={'People'} />, path: '/people' },
    { element: <PeoplePremiuimRecheck currentTab={'Premium'} />, path: '/premium' },
    { element: <PeoplePremiuimRecheck currentTab={'Recheck'} />, path: '/recheck' },
    { element: <BaitProfiles />, path: '/baitprofiles' },
    { element: <PhoneNumber />, path: '/phonenumbers' },
    { element: <ImageLabel />, path: '/imagelabel' },
    { element: <Sharing />, path: '/sharing' },
    { element: <Navigate to="/people" />, path: '*' },
    { element: <FeedAutoCurated />, path: '/feedAutoCurated' },
    { element: <PeopleHNI currentTab={'PeopleHNI'} />, path: '/peopleHNI'},
    { element: <Event />, path: '/event' }
])


function App() {
    return (
        <RouterProvider router={router}>

        </RouterProvider>
    );
}

export default App;
